<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <MenuCard :menuItems="visibleMenuItems" />
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";
import { sessionHelper } from "@/utils";

export default {
  page: {
    title: i18n.t("module.communication"),
  },
  components: { Layout, PageHeader, MenuCard },
  computed: {
    visibleMenuItems() {
      const user = this.$store.state.api.auth.user?.user;
      const level =
        sessionHelper.getUserPermissions(user?.permissions, user?.isSuperadmin)
          .event_admin || 0;
      return this.menuItems.filter(
        (item) => item.route !== "Event" || level >= 1,
      );
    },
  },
  data() {
    return {
      title: i18n.t("module.communication"),
      items: [
        {
          text: i18n.t("module.communication"),
          active: true,
        },
      ],
      menuItems: [
        {
          route: "Report",
          label: i18n.t("module.report"),
          icon: "mdi-file-document-outline",
          color: "danger",
          core: true,
          maintenance: false,
        },
        {
          route: "Article",
          label: i18n.t("module.article"),
          icon: "mdi-text-box",
          color: "info",
          core: true,
          maintenance: false,
        },
        {
          route: "Event",
          label: i18n.t("module.event"),
          icon: "mdi-calendar-outline",
          color: "success",
          core: true,
          maintenance: false,
        },
        {
          route: "Marketplace",
          label: i18n.t("module.marketplace"),
          icon: "mdi-store",
          color: "primary",
          core: true,
          maintenance: false,
        },
        {
          route: "Notification",
          label: i18n.t("module.notification"),
          icon: "mdi-bell",
          color: "warning",
          core: true,
          maintenance: false,
        },
        {
          route: "Document",
          label: i18n.t("module.document"),
          icon: "mdi-file-document-outline",
          color: "secondary",
          core: true,
          maintenance: false,
        },
        {
          route: "Catalog",
          label: i18n.t("module.catalog"),
          icon: "mdi-book-open-page-variant",
          color: "danger",
          core: true,
          maintenance: false,
        },
        {
          route: "SportClub",
          label: i18n.t("module.sportClub"),
          icon: "mdi-basketball",
          color: "warning",
          core: true,
          maintenance: false,
        },
        {
          route: "PrivacyPolicy",
          label: i18n.t("module.privacyPolicy"),
          icon: "mdi-shield-lock-outline",
          color: "info",
          core: true,
          maintenance: false,
          externalLink: true,
        },
        {
          route: "ArticleCategory",
          label: i18n.t("module.articleCategory"),
          icon: "mdi-shape",
          color: "info",
          core: false,
          maintenance: false,
        },
        {
          route: "NotificationIcon",
          label: i18n.t("module.notificationIcon"),
          icon: "mdi-image-multiple",
          color: "warning",
          core: false,
          maintenance: false,
        },
        {
          route: "NotificationChannel",
          label: i18n.t("module.notificationChannel"),
          icon: "mdi-access-point-network",
          color: "primary",
          core: false,
          maintenance: false,
        },
        {
          route: "DocumentCategory",
          label: i18n.t("module.documentCategory"),
          icon: "mdi-folder-multiple",
          color: "primary",
          core: false,
          maintenance: false,
        },
        {
          route: "CatalogCategory",
          label: i18n.t("module.catalogCategory"),
          icon: "mdi-folder",
          color: "success",
          core: false,
          maintenance: false,
        },
        {
          route: "CatalogSubcategory",
          label: i18n.t("module.catalogSubcategory"),
          icon: "mdi-folder-multiple-outline",
          color: "info",
          core: false,
          maintenance: false,
        },
      ],
    };
  },
};
</script>
